import { z } from 'zod';

import { oneOrMany } from '../../utils.js';

export enum HumanTaskCategoryStatus {
  Active = 'Active',
  SoftDeleted = 'SoftDeleted',
}

export const BaseHumanTaskCategorySchema = z.object({
  name: z.string().min(1),
  description: z.string(),
  organizationId: z.string().uuid(),
  state: z.nativeEnum(HumanTaskCategoryStatus),
});
export type BaseHumanTaskCategory = z.infer<typeof BaseHumanTaskCategorySchema>;

export const HumanTaskCategorySchema = BaseHumanTaskCategorySchema.extend({
  id: z.string(),
  created: z.string().date(),
  updated: z.string().date(),
});
export type HumanTaskCategory = z.infer<typeof HumanTaskCategorySchema>;

export type HumanTaskCategoryBasic = Pick<HumanTaskCategory, 'id' | 'name'>;

export const HumanTaskCategoryQueryParamsSchema = z.object({
  q: z.string().optional(),
  id: oneOrMany(z.string().uuid()).optional(),
  organizationId: oneOrMany(z.string().uuid()).optional(),
  name: z.string().optional(),
  limit: z.coerce.number().positive().optional(),
  offset: z.coerce.number().min(0).optional(),
  state: z.nativeEnum(HumanTaskCategoryStatus).optional(),
});
export type HumanTaskCategoryQueryParams = z.infer<typeof HumanTaskCategoryQueryParamsSchema>;

export const BaseHumanTaskCategoryUserSchema = z.object({
  categoryId: z.string().uuid(),
  userId: z.string().uuid(),
});
export type BaseHumanTaskCategoryUser = z.infer<typeof BaseHumanTaskCategoryUserSchema>;

export const HumanTaskCategoryUserSchema = BaseHumanTaskCategoryUserSchema.extend({
  id: z.string(),
  created: z.string().date(),
});
export type HumanTaskCategoryUser = z.infer<typeof HumanTaskCategoryUserSchema>;

export const HumanTaskCategoryUsersParamsSchema = z.object({
  categoryId: z.string().uuid(),
});
export type HumanTaskCategoryUsersParams = z.infer<typeof HumanTaskCategoryUsersParamsSchema>;

export const HumanTaskCategoryUserQueryParamsSchema = z.object({
  limit: z.coerce.number().positive().optional(),
  offset: z.coerce.number().min(0).optional(),
});
export type HumanTaskCategoryUserQueryParams = z.infer<
  typeof HumanTaskCategoryUserQueryParamsSchema
>;
